import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function RefreshIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" fill="none" viewBox="0 0 20 20" {...props}>
      <Box
        as="path"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M18.96 3.46v5h-5M.62 16.79v-5h5"
      />
      <Box
        as="path"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M2.72 7.63a7.485 7.485 0 0 1 9.57-4.57c1.05.37 2.01.98 2.8 1.77l3.87 3.63M.62 11.79l3.87 3.63a7.502 7.502 0 0 0 10.61 0c.79-.79 1.4-1.75 1.77-2.8"
      />
    </Icon>
  );
}
